import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {IRanking} from '../type';

export interface IStateRanking {
  ranking: IRanking;
}

const INITIAL_STATE: IStateRanking = {
  ranking: {
    tabs: [],
    talkBoards: [],
  },
};

export default createReducer<
  IStateRanking,
  ReducerActionHelper<typeof actions>
>(INITIAL_STATE, {
  ...createBasicReducerHandlers({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  [ActionType.SetRankingTabContents]: (state, action) => {
    const {
      tag,
      adminSectionList,
      isRankingInProgress,
      rankingSectionTitle,
      rankingList,
    } = action.payload;
    const tabState = state.ranking.tabs.find(item => item.tag === tag);
    if (tabState) {
      tabState.adminSectionList = adminSectionList;
      tabState.isRankingInProgress = isRankingInProgress;
      tabState.rankingSectionTitle = rankingSectionTitle;
      tabState.rankingList = rankingList;
    }
  },
});
